"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectModal = void 0;
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_modal_1 = __importDefault(require("react-modal"));
var ProviderSelect_1 = require("../components/ProviderSelect");
var constants_1 = require("../constants");
var screens_1 = require("../screens");
var wallet_connect_custom_1 = require("../screens/wallet-connect-custom");
var use_contractkit_1 = require("../use-contractkit");
var sort_1 = require("../utils/sort");
var styles_1 = require("./styles");
function walletToScreen(wallet) {
    var WalletConnectCustomWrapper = function (_a) {
        var onSubmit = _a.onSubmit;
        return (react_1.default.createElement(wallet_connect_custom_1.WalletConnectCustom, { onSubmit: onSubmit, wallet: wallet }));
    };
    return WalletConnectCustomWrapper;
}
function walletToProvider(wallet) {
    return {
        name: wallet.name,
        type: constants_1.WalletTypes.WalletConnect,
        description: wallet.description || 'Missing description in registry',
        icon: wallet.logos.md,
        canConnect: function () { return true; },
        showInList: function () {
            return react_device_detect_1.isMobile ? Object.values(wallet.mobile).some(Boolean) : true;
        },
        listPriority: function () { return 0; },
        installURL: wallet.homepage,
    };
}
var ConnectModal = function (_a) {
    var reactModalProps = _a.reactModalProps, _b = _a.RenderProvider, RenderProvider = _b === void 0 ? ProviderSelect_1.ProviderSelect : _b, _c = _a.screens, screens = _c === void 0 ? screens_1.defaultScreens : _c, _d = _a.title, title = _d === void 0 ? 'Connect a wallet' : _d, _e = _a.providersOptions, providersOptions = _e === void 0 ? {} : _e;
    var connectionCallback = (0, use_contractkit_1.useContractKitInternal)().connectionCallback;
    var _f = __read((0, react_1.useState)(null), 2), adding = _f[0], setAdding = _f[1];
    var _g = __read((0, react_1.useState)(false), 2), showMore = _g[0], setShowMore = _g[1];
    var hideFromDefaults = providersOptions.hideFromDefaults, additionalWCWallets = providersOptions.additionalWCWallets, _h = providersOptions.sort, sort = _h === void 0 ? sort_1.defaultProviderSort : _h;
    var _j = (0, react_1.useMemo)(function () {
        var _screens;
        var _wallets = (additionalWCWallets || []);
        if (hideFromDefaults) {
            if (hideFromDefaults === true) {
                _screens = {};
            }
            else {
                _screens = Object.keys(screens)
                    .filter(function (x) { return !hideFromDefaults.includes(x); })
                    .reduce(function (acc, provider) {
                    var _a;
                    return (__assign(__assign({}, acc), (_a = {}, _a[provider] = screens[provider], _a)));
                }, {});
            }
        }
        else {
            _screens = screens;
        }
        return {
            wallets: _wallets,
            allScreens: __assign(__assign({}, _screens), _wallets.reduce(function (acc, wallet) {
                acc[wallet.id] = walletToScreen(wallet);
                return acc;
            }, {})),
        };
    }, [screens, hideFromDefaults, additionalWCWallets]), wallets = _j.wallets, allScreens = _j.allScreens;
    var _providers = (0, react_1.useMemo)(function () { return (__assign(__assign({}, constants_1.PROVIDERS), wallets.reduce(function (acc, wallet) {
        acc[wallet.id] = walletToProvider(wallet);
        return acc;
    }, {}))); }, [wallets]);
    var close = (0, react_1.useCallback)(function () {
        setAdding(null);
        setShowMore(false);
        connectionCallback === null || connectionCallback === void 0 ? void 0 : connectionCallback(false);
    }, [connectionCallback]);
    var onSubmit = (0, react_1.useCallback)(function (connector) {
        setAdding(null);
        connectionCallback === null || connectionCallback === void 0 ? void 0 : connectionCallback(connector);
    }, [connectionCallback]);
    var onToggleShowMore = (0, react_1.useCallback)(function () {
        setShowMore(function (state) { return !state; });
    }, []);
    var providers = (0, react_1.useMemo)(function () {
        return Object.entries(_providers)
            .filter(function (_a) {
            var _b = __read(_a, 2), providerKey = _b[0], provider = _b[1];
            return typeof window !== 'undefined' &&
                provider.showInList() &&
                Object.keys(allScreens).find(function (screen) { return screen === providerKey; });
        })
            .sort(function (_a, _b) {
            var _c = __read(_a, 2), a = _c[1];
            var _d = __read(_b, 2), b = _d[1];
            return sort(a, b);
        });
    }, [_providers, allScreens, sort]);
    var hasMoreItems = providers.length > 5; // TODO: is 5 a good default?
    var prioritizedProviders = (0, react_1.useMemo)(function () {
        return hasMoreItems
            ? providers.filter(function (_a) {
                var _b = __read(_a, 2), provider = _b[1];
                return provider.listPriority() === 0;
            })
            : providers;
    }, [providers, hasMoreItems]);
    var modalContent;
    if (!adding) {
        var providersToDisplay = showMore ? providers : prioritizedProviders;
        modalContent = (react_1.default.createElement("div", { className: "tw-flex tw-flex-col tw-items-stretch" },
            react_1.default.createElement("h1", { className: "tw-pl-3 tw-pb-2 tw-text-lg tw-font-medium dark:tw-text-gray-300" }, title),
            providersToDisplay.map(function (_a) {
                var _b = __read(_a, 2), providerKey = _b[0], provider = _b[1];
                return (react_1.default.createElement(RenderProvider, { key: providerKey, provider: provider, onClick: function () { return setAdding(providerKey); } }));
            }),
            hasMoreItems && (react_1.default.createElement("button", { onClick: onToggleShowMore, className: "tw-font-medium tw-text-md tw-w-32 tw-self-center tw-mt-4 tw-text-blue-800 dark:tw-text-blue-400 hover:tw-text-blue-600 focus:tw-outline-none" },
                "Show ",
                showMore ? 'Less' : 'More'))));
    }
    else {
        var ProviderElement = allScreens === null || allScreens === void 0 ? void 0 : allScreens[adding];
        if (!ProviderElement) {
            return null;
        }
        modalContent = react_1.default.createElement(ProviderElement, { onSubmit: onSubmit });
    }
    return (react_1.default.createElement(react_modal_1.default, __assign({ isOpen: !!connectionCallback, onRequestClose: close, style: styles_1.defaultModalStyles, overlayClassName: "tw-fixed tw-bg-gray-100 dark:tw-bg-gray-700 tw-bg-opacity-75 tw-inset-0" }, reactModalProps, { ariaHideApp: false }),
        react_1.default.createElement("div", { className: "use-ck tw-bg-white dark:tw-bg-gray-800 tw-p-2" },
            react_1.default.createElement("div", { className: "tw-relative use-ck-connect-container" },
                react_1.default.createElement("button", { onClick: close, className: "tw-absolute tw-top-3 tw-right-2 tw-text-gray-700 dark:tw-text-gray-400 hover:tw-text-gray-800 dark:hover:tw-text-gray-300 hover:tw-bg-gray-100 dark:hover:tw-bg-gray-700 tw-p-1 tw-rounded" },
                    react_1.default.createElement("svg", { className: "tw-h-5 tw-w-5", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
                        react_1.default.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" })),
                    ' '),
                react_1.default.createElement("div", { className: "tw-px-4 tw-py-4" }, modalContent)))));
};
exports.ConnectModal = ConnectModal;
//# sourceMappingURL=connect.js.map